import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';
import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';

const OOS_REASONS_PATH = '/api/OutOfServiceReasons';

const routes = {
  safetyOOSReasonsPath: () => '/api/OutOfServiceReasons/',
  safetyOOSReasonsGridPath: () => `${routes.safetyOOSReasonsPath()}Grid`,
  oosReasonAuditsPathById: (id, params) => `${routes.safetyOOSReasonsPath()}${id}/Audits${getQueryParams(params)}`,
  oosReasonAuditPropertiesPathById: (id) => `${routes.safetyOOSReasonsPath()}${id}/Audits/Properties`,
  oosReasonAuditUsersPathById: (id) => `${routes.safetyOOSReasonsPath()}${id}/Audits/Users`,
  restoreOOSReasonPathById: (id) => `${routes.safetyOOSReasonsPath()}${id}/restore`,
  deleteOOSReasonPathById: (id) => `${routes.safetyOOSReasonsPath()}${id}`,
};

export const getOutOfServiceReasonsGrid = (params) =>
  makeRequest(authFetch.get(`${routes.safetyOOSReasonsGridPath()}${getQueryParams({ ...params })}`));

export const getOutOfServiceReasons = () => makeRequest(authFetch.get(OOS_REASONS_PATH));
export const useGetOutOfServiceReasons = (opts = {}) => useQuery(
  ['outOfServiceReasons'], getOutOfServiceReasons, { ...CacheConfig.forever, ...opts },
);

export const deleteOutOfServiceReasons = (id) => makeRequest(authFetch.delete(routes.deleteOOSReasonPathById(id)));
export const restoreOutOfServiceReasons = (id) => makeRequest(authFetch.patch(routes.restoreOOSReasonPathById(id)));
export const getOutOfServiceReasonsAudits = (id, params) =>
  makeRequest(authFetch.get(routes.oosReasonAuditsPathById(id, params)));
export const getOutOfServiceReasonsAuditProperties = (id) =>
  makeRequest(authFetch.get(routes.oosReasonAuditPropertiesPathById(id)));
export const getOutOfServiceReasonsAuditUsers = (id) =>
  makeRequest(authFetch.get(routes.oosReasonAuditUsersPathById(id)));

export const putOutOfServiceReasons = (data) => makeRequest(authFetch.put('/api/OutOfServiceReasons', data));
export const getOutOfServiceReasonsTypes = async () =>
  await makeRequest(authFetch.get('/api/OutOfServiceReasons/Types'));
